import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import Brand from '../components/Brand';
import Icon from '../components/Icon';

export default function BlockedPage({ profile }) {
  return (
    <main className="blocked-page">
      <div className="onboarding-card">
        <Brand />
        <div className="empty-icon">
          <Icon name="close" size={28} />
        </div>
        <h1>Account restricted</h1>
        <p>
          {profile?.blockedReason ||
            'This account has been restricted. Contact support if you think this is a mistake.'}
        </p>
        <button type="button" className="secondary-button" onClick={() => signOut(auth)}>
          Sign out
        </button>
      </div>
    </main>
  );
}
